export class InviaNotificaAggiornamentoRequest {
  username: string;
  testoNotifica: string;
}

